import React, { useEffect, useRef } from "react";
import "./index.scss";

function ChromaKeyVideo({ origin, videoRef, src, chromaColor = { r: 255, g: 0, b: 0 }, sensitivity = { r: 70 , g: 100 , b: 80 }, isLoop, canvasClass, autoPlay, chromaClass, isMuted, avatar}) {
  
  const canvasRef = useRef(null);
 

  // useEffect(() => {
  //   const video = videoRef.current;
  //   const canvas = canvasRef.current;
  //   const ctx = canvas.getContext("2d");

  //   const handleLoadedData = () => {
  //     canvas.width = video.videoWidth;
  //     canvas.height = video.videoHeight;

  //     video.crossOrigin = "";
  //     const chromaKey = () => {
  //       ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

  //       const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  //       const dataLength = imageData.data.length / 4;

  //       for (let i = 0; i < dataLength; i++) {
  //         const offset = i * 4;
  //         const red = imageData.data[offset + 0];
  //         const green = imageData.data[offset + 1];
  //         const blue = imageData.data[offset + 2];

  //         if (
  //           Math.abs(red - chromaColor.r) < sensitivity.r &&
  //           Math.abs(green - chromaColor.g) < sensitivity.g &&
  //           Math.abs(blue - chromaColor.b) < sensitivity.b
  //         ) {
  //           imageData.data[offset + 3] = 0;
  //         }
  //       }
  //       imageData.crossOrigin = "Anonymous";
  //       ctx.putImageData(imageData, 0, 0);
  //     };

  //     const intervalId = setInterval(chromaKey, 40);
  //     return () => clearInterval(intervalId);
  //   };
  //   if (video.readyState >= 3) {
  //       handleLoadedData();
  //     } else {
  //       video.addEventListener("loadeddata", handleLoadedData);
  //       return () => {
  //         video.removeEventListener("loadeddata", handleLoadedData);
  //       };
  //     }
   
  // }, [src]);

  return (
    <div className={`chroma-key-video ${chromaClass} ${origin}`}>
      <video
        ref={videoRef}
        src={src}
        autoPlay={autoPlay}
        playsInline
        loop={isLoop}
        muted={isMuted}
        style={{ opacity: 0 }}
        crossOrigin=""
      />
      <canvas 
      ref={canvasRef}
      className={canvasClass}
       />
    </div>
  );
}

export default ChromaKeyVideo;
